import type { FC } from 'react';
import type { CategoryNavigationItemSERP } from '../../api/rest/types';
import { CategoryFilterStandalone } from '../CategoryFilterStandalone';
import { useSearchResultDataForCategoryFilter } from './useSearchResultDataForCategoryFilter';

export type SearchResultCategoryFilterProps = {
  /** The current category tree, flattened and sorted by selection */
  categories: CategoryNavigationItemSERP[];
  /** If `true`, shows a dedicated "clear all" interaction/button in addition to the root level category */
  showClearAll?: boolean;
  /** Callback fired when a category is clicked or all categories are cleared */
  onNavigate?: () => void;
};

/**
 * Formats SERP category navigation items to be used in CategoryFilterStandalone component
 * */
export const SearchResultCategoryFilter: FC<SearchResultCategoryFilterProps> = ({
  categories,
  showClearAll,
  onNavigate,
}) => {
  const items = useSearchResultDataForCategoryFilter(categories);

  return (
    <CategoryFilterStandalone
      categories={items}
      showClearAll={showClearAll}
      onNavigate={onNavigate}
    />
  );
};
